interface AllocationInput {
  project_id: number;
  hours: string | number;
}

export function recomputeAllocations(
  allocations: AllocationInput[],
  targetTotalHours: number,
): Array<{ project_id: number; hours: string }> {
  const previousTotal = allocations.reduce((sum, a) => sum + Number(a.hours), 0);
  if (previousTotal === 0) return [];

  const scale = targetTotalHours / previousTotal;
  const items = allocations.map((a) => ({
    project_id: a.project_id,
    hours: Number((Number(a.hours) * scale).toFixed(2)),
  }));

  const sum = items.reduce((s, i) => s + i.hours, 0);
  const diff = Number((targetTotalHours - sum).toFixed(2));
  if (diff !== 0 && items.length > 0) {
    const largest = items.reduce((max, item) => (item.hours > max.hours ? item : max), items[0]);
    largest.hours = Number((largest.hours + diff).toFixed(2));
  }

  return items.map((i) => ({ project_id: i.project_id, hours: String(i.hours) }));
}
